import { render } from "./AppLayoutError.vue?vue&type=template&id=6d8d3462&scoped=true"
import script from "./AppLayoutError.vue?vue&type=script&lang=js"
export * from "./AppLayoutError.vue?vue&type=script&lang=js"

import "./AppLayoutError.vue?vue&type=style&index=0&id=6d8d3462&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Web.API\\client-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8d3462"]])

export default __exports__